<template>
    <div class="mx-3">
        <attorney-dispute-document-association-modal></attorney-dispute-document-association-modal>
        <attorney-dispute-note-association-modal></attorney-dispute-note-association-modal>
        <document-tags></document-tags>
        <document-notes-modal></document-notes-modal>

        <div v-if="showHistoricalToggle" class="d-flex justify-content-end align-items-end">
            <div class="btn-group btn-group-sm btn-group-toggle mb-1" data-toggle="buttons">
                <label :class="['btn-state btn btn-secondary', {'active': historicalState === HistoricalState.ALL}]">
                    <input type="radio" autocomplete="off" :value="HistoricalState.ALL" :checked="historicalState === HistoricalState.ALL" @change="changeState($event.target)"> All
                </label>
                <label :class="['btn-state btn btn-secondary', {'active': historicalState === HistoricalState.NONE}]">
                    <input type="radio" autocomplete="off" :value="HistoricalState.NONE" :checked="historicalState === HistoricalState.NONE" @change="changeState($event.target)"> No Historical
                </label>
                <label :class="['btn-state btn btn-secondary', {'active': historicalState === HistoricalState.ONLY}]">
                    <input type="radio" autocomplete="off" :value="HistoricalState.ONLY" :checked="historicalState === HistoricalState.ONLY" @change="changeState($event.target)"> Historical Only
                </label>                
            </div>
        </div>

        <attorney-claim-detail :data-claim="claim" :states="states" :href="href"></attorney-claim-detail>
        <attorney-disputes :client-id="claim.client_id" :claim-id="claim.claim_id"></attorney-disputes>
        <attorney-service-documents :client-id="claim.client_id" :claim-id="claim.claim_id" :state="historicalState"></attorney-service-documents>
        <basic-submission-history-modal></basic-submission-history-modal>        
        <!-- <attorney-documents :client-id="claim.client.id" :claim-id="claim.claim_id" title="Health Insurance Claim Forms" subtitle="CMS 1500/1450" :href="'/ajax/attorney/claims/' + claim.claim_id + '/documents/services'" doc-type="cms"></attorney-documents>
        <attorney-documents :client-id="claim.client.id" :claim-id="claim.claim_id" title="Requests For Authorization" subtitle="LWC Form 1010" :href="'/ajax/attorney/claims/' + claim.claim_id + '/documents/authorizations'" doc-type="1010"></attorney-documents>
        <attorney-documents :client-id="claim.client.id" :claim-id="claim.claim_id" title="Medical Treatment Disputes" subtitle="LWC Form 1009" :href="'/ajax/attorney/claims/' + claim.claim_id + '/documents/authorizations/disputes'" doc-type="1009"></attorney-documents>
        <attorney-documents :client-id="claim.client.id" :claim-id="claim.claim_id" title="Received Correspondence" subtitle="" :href="'/ajax/attorney/claims/' + claim.claim_id + '/documents/received'" doc-type="recvd"></attorney-documents>
        <attorney-documents :client-id="claim.client.id" :claim-id="claim.claim_id" title="Other Documents" :href="'/ajax/attorney/claims/' + claim.claim_id + '/documents/others'" doc-type="other"></attorney-documents> -->
        <attorney-claim-notes :claim-id="claim.claim_id"></attorney-claim-notes>
    </div>    
</template>

<script>
import { HistoricalState } from '../../constants.js';
import AttorneyDisputeDocumentAssociationModal from './AttorneyDisputeDocumentAssociationComponent.vue';
import AttorneyClaimDetail from './AttorneyClaimDetailComponent.vue';
import AttorneyDisputes from './AttorneyDisputesComponent.vue';
import AttorneyServiceDocuments from './AttorneyServiceDocumentsComponent.vue';
import BasicSubmissionHistoryModal from '../transmissions/BasicSubmissionHistoryComponent.vue';
// import AttorneyDocuments from './AttorneyDocumentsComponent.vue';
import AttorneyClaimNotes from './AttorneyClaimNotesComponent.vue';
import AttorneyDisputeNoteAssociationModal from './AttorneyDisputeNoteAssociationComponent.vue';
import DocumentTags from '../documents/DocumentTagsComponent.vue';
import DocumentNotesModal from '../documents/DocumentNotesModalComponent.vue';

export default {
    components: {
        AttorneyDisputeDocumentAssociationModal,
        AttorneyClaimDetail,
        AttorneyDisputes,
        AttorneyServiceDocuments,
        BasicSubmissionHistoryModal,        
        // AttorneyDocuments,
        AttorneyClaimNotes,
        AttorneyDisputeNoteAssociationModal,
        DocumentTags,
        DocumentNotesModal        
    },
    props: {
        claim: Object,
        states: Array,
        href: String,
        documentId: String
    },
    data () {
        return {
            HistoricalState: HistoricalState,
            historicalState: HistoricalState.ALL
        }
    },
    computed: {
        showHistoricalToggle: function () {
            return this.claim.has_historical_documents && this.claim.has_non_historical_documents;
        }  
    },
    methods: {
        changeState: function (target) {

            if (target && target.checked) {
                this.historicalState = parseInt(target.value);
            }
        }
    }      
}
</script>

<style scoped>

</style>